/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import Button from "@mui/material/Button";
import { ContentZoneContext } from "cms/components/context/index";
import { SVGIcons } from "cms/icons/svg-icons";
import { useContentZone } from "cms/components/hooks/use-content-zone";

const ComponentEditorHeaderButtons = () => {
    
    // const { label } = props
    const {
        fieldName,
        // updatedComponent,
        component,
        // isDirty,
        // setIsDirty,
        editMode,
        preview,
    } = useContext(ContentZoneContext);
    // const { guid, reuse_count } = component
    // const { token } = useAuth()
    
    const {
        // handleUpdateComponent,
        handleDeleteComponent,
    } = useContentZone();
    
    // const [showConfirmEditModal, setShowConfirmEditModal] = useState(false)
    // const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
    
    /*
     TODO:
         eventually remove this look up.
         reuse_count can be pre-populated to provide usage without a lookup (until you click for more info)
         but having this query here for now fixes cases where the data is not up to date yet
         reuse_count is populated when components are saved.
     */
    // const [usage, setUsage] = useState()
    // const [usageCount, setUsageCount] = useState(reuse_count)
    // useEffect(() => {
    //     const fetchUsage = async () => {
    //         if (isValidGuid(guid)) {
    //             let _usage = await SimpliCityAdminSDK.component.getComponentUsage(token, guid)
    //             if (_usage) {
    //                 setUsage(_usage)
    //                 setUsageCount(_usage?.length)
    //                 Logger.debug('setUsage', _usage)
    //             }
    //         }
    //     }
    //     fetchUsage()
    // }, [guid])
    
    // const handleConfirmSave = async () => {
    //     setShowConfirmEditModal(false)
    //     await handleUpdateComponent(fieldName, updatedComponent)
    // }
    // const handleConfirmCancel = async () => {
    //     setShowConfirmEditModal(false)
    // }
    const onRemove = async (event) => {
        event.stopPropagation();
        await handleDeleteComponent(fieldName, component);
    };
    // const onSaveLabel = async (event) => {
    //     event.stopPropagation()
    //     // if (usageCount > 1) {
    //     //     setShowConfirmEditModal(true)
    //     // } else {
    //     const _updatedComponent = structuredClone(component)
    //     const updatedComponent = {
    //         ..._updatedComponent,
    //         label,
    //     }
    //     if (Config.Logging.enableSavePipelineLog) {
    //         Logger.debug(`%c      CHANGED     [ComponentEditorHeader] `, 'color: black; background-color: limegreen')
    //         Logger.debug(label, updatedComponent)
    //     }
    //     await handleUpdateComponent(fieldName, updatedComponent)
    //     setIsDirty(false)
    //     // }
    // }
    
    // function getEditConfirmMessage() {
    //     return `Changes you make her will affect <strong>${usageCount} other instances.</strong>`
    // }
    
    return (
        <>
            <div className='simplicity-composer-header-subgroup component-actions'>
                {/*  FIXME: The use of preview here (to hide include and things by display: none) is not acceptable  */}
                {!preview && editMode &&
                    <>
                        <Button
                            size={"small"}
                            name={"Remove"}
                            variant='outlined'
                            color='neutral'
                            onClick={onRemove}
                            startIcon={<SVGIcons.common.Cancel />}
                        >
                            Remove
                        </Button>
                        {/*{isDirty &&*/}
                        {/*    <Button*/}
                        {/*        size={'small'}*/}
                        {/*        name={'Save'}*/}
                        {/*        variant='contained'*/}
                        {/*        color='action'*/}
                        {/*        onClick={onSaveLabel}*/}
                        {/*        disabled={!isDirty}*/}
                        {/*        startIcon={<SVGIcons.common.Save />}*/}
                        {/*    >*/}
                        {/*        Save*/}
                        {/*    </Button>*/}
                        {/*}*/}
                    </>
                }
            </div>
            {/*<ConfirmDialog*/}
            {/*    open={showConfirmEditModal}*/}
            {/*    onCancel={handleConfirmCancel}*/}
            {/*    primaryAction={handleConfirmSave}*/}
            {/*    secondaryAction={handleConfirmCancel}*/}
            {/*    title={'Reminder'}*/}
            {/*    message={getEditConfirmMessage()}*/}
            {/*/>*/}
        </>
    );
};

// ComponentEditorHeaderButtons.displayName = ''
export { ComponentEditorHeaderButtons };
